import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

import { FormSection } from 'common/components/FormSection';
import { FileField, TextField } from 'common/forms/Field';
import { TControllerProps } from 'common/types';
import {
    CERTIFICATE_SIGNATURE_FILE_MAX_SIZE,
    CERTIFICATE_SIGNATURE_FILE_TYPES,
} from 'common/constants/files';
import { IFileFragment } from 'graphql/types';
import { TCertificateFormValues } from 'certificate/types';

interface IProps extends TControllerProps<TCertificateFormValues> {
    signatureFile?: IFileFragment | null;
    onSignatureFileUpload?: (file: IFileFragment | null) => void;
}

export const InformationSection = ({
    control,
    signatureFile,
    onSignatureFileUpload,
}: IProps) => {
    const [translate] = useTranslation();

    const {
        formState: { errors },
    } = useFormContext();

    const hasError = !!errors.title?.message;

    return (
        <FormSection
            renderExpanded
            description={
                <Box>{translate('certificateForm.informationDescription')}</Box>
            }
            hasError={hasError}
            title={translate('certificateForm.informationTitle')}
        >
            <TextField
                control={control}
                label={translate('title')}
                name="title"
            />

            <TextField
                control={control}
                label={translate('subtitle')}
                name="subtitle"
            />

            <TextField
                multiline
                control={control}
                label={translate('description')}
                name="text"
            />

            <Box sx={{ mt: 3 }}>
                <FileField
                    acceptedFileTypes={CERTIFICATE_SIGNATURE_FILE_TYPES}
                    control={control}
                    displayFile={signatureFile}
                    helperText={translate('fileHelperText', {
                        count: CERTIFICATE_SIGNATURE_FILE_MAX_SIZE,
                    })}
                    id="signatureFile"
                    label={translate('certificateForm.signatureFile')}
                    maxUploadSize={CERTIFICATE_SIGNATURE_FILE_MAX_SIZE}
                    name="signatureFileId"
                    onFileUpload={onSignatureFileUpload}
                />
            </Box>
        </FormSection>
    );
};
